import React from "react";
import { useNavigate } from "react-router-dom";
import gujaratiKakkoData from "../../utils/gujaratiKakko/gujaratiKakkoData";
import { ColorArray } from "../../config/ColorArray";
import "./GujaratiKakko.css";
import { imageUrl } from "../../utils/imageUrl";   // ✅ FIXED IMPORT
import SectionDivider from "../../common/SectionDivider";

const GujaratiKakko = () => {
    const navigate = useNavigate();

    const getCardColor = (index) => {
        return ColorArray[index % ColorArray.length]?.color2;
    };

    return (
        <>
        <SectionDivider title="ગુજરાતી કક્કો" />
        <div className="kakko-container">

            <div className="kakko-grid">
                {gujaratiKakkoData.map((item, index) => {
                    const textColor = getCardColor(index);

                    return (
                        <div className="kakko-card" key={index}>

                            {/* LEFT TEXT */}
                            <div className="kakko-left">
                                <span
                                    className="kakko-letter"
                                    style={{ color: textColor }}
                                >
                                    {item.axar || item.char}
                                </span>

                                <span
                                    className="kakko-word"
                                    style={{ color: textColor }}
                                >
                                    {item.title || item.word}
                                </span>
                            </div>

                            {/* RIGHT IMAGE */}
                            <div className="kakko-right">
                                {item.image ? (
                                    <img
                                        src={imageUrl(item.image)}   // ✅ MAIN FIX
                                        className="kakko-img"
                                        alt=""
                                        onError={(e) => {
                                            e.target.style.display = "none";
                                        }}
                                    />
                                ) : (
                                    <span className="kakko-emoji">{item.img}</span>
                                )}
                            </div>

                        </div>
                    );
                })}
            </div>
        </div>
        </>
    );
};

export default GujaratiKakko;
